import React from 'react'

export const Message = () => {
  return (
    <div className="alert alert-light alert-dismissible fade show" role="alert" style={{background: '#46c79e', color: '#fff'}}>
        <span className='fs-5'>Welcome to my personalized repository!</span>
        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
  )
}
